module.exports = __webpack_public_path__ + "static/media/tablet_icon.a6794449.jpg";